import { Routes } from '@angular/router';
import { BlogContainerComponent } from './blog-container/blog-container.component';
import { AgenticAiComponent } from './agentic-ai/agentic-ai.component';
import { AitoolsProjectManagementComponent } from './aitools-project-management/aitools-project-management.component';
import { BlogBusinessProcessAutomationComponent } from './blog-business-process-automation/blog-business-process-automation.component';
import { BlogCoversComponent } from './blog-covers/blog-covers.component';
import { BlogCustomWebdevComponent } from './blog-custom-webdev/blog-custom-webdev.component';
import { BlogSoftwarereqAnalysisComponent } from './blog-softwarereq-analysis/blog-softwarereq-analysis.component';
import { DevopsGuideComponent } from './devops-guide/devops-guide.component';
import { DigitalChallengesComponent } from './digital-challenges/digital-challenges.component';
import { BlogObfuscationComponent } from './blog-obfuscation/blog-obfuscation.component';
import { BlogDigitalTransformationComponent } from './blog-digital-transformation/blog-digital-transformation.component';
import { IosUpdatesComponent } from './ios-updates/ios-updates.component';
import { RagChatbotComponent } from './rag-chatbot/rag-chatbot.component';
import { WebsiteUsingaiComponent } from './website-usingai/website-usingai.component';
import { WhatIsArtificialGeneralIntelligenceAgiComponent } from './what-is-artificial-general-intelligence-agi/what-is-artificial-general-intelligence-agi.component';
import { AgenticAiInSdlcComponent } from './agentic-ai-in-sdlc/agentic-ai-in-sdlc.component';
import { AGIImplementationGuideComponent } from './agi-implementation-guide/agi-implementation-guide.component';
import { AiAgentsInEnterprisesComponent } from './ai-agents-in-enterprises/ai-agents-in-enterprises.component';
import { AutonomousMachineRevolutionComponent } from './autonomous-machine-revolution/autonomous-machine-revolution.component';
import { DataVisualizationSkills2026Component } from './data-visualization-skills-2026/data-visualization-skills-2026.component';
import { AiCodingToolsForDevelopersComponent } from './ai-coding-tools-for-developers/ai-coding-tools-for-developers.component';

export const BLOG_ROUTES: Routes = [
  {
    path: "", component: BlogContainerComponent, children: [
      {
        path: "blog", component: BlogCoversComponent,
        data: {
          title: 'Read the latest insights on advanced technology | Blog ',
          description: 'Read our latest blogs on innovative and advanced technologies that boost business processes and take business to the next level.',
          keywords: 'Blog',
          image: '',
          url: 'https://www.kalpitatechnologies.com/blogs/blog'
        }
      },
      {
        path: "digital-challenges", component: DigitalChallengesComponent,
        data: {
          title: '7 Digital Transformation Challenges and Solutions to Overcome in 2023. ',
          description: 'Discover the strategic solutions to overcome the challenges of digital transformation in 2023 with reports from authentic sources.',
          keywords: 'Enterprise Digital transformation, digital transformation',
          image: 'https://www.kalpitatechnologies.com/assets/blog/digital-challenges/digiChallenge-cover.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/digital-challenges'
        }
      },
      {
        path: "business-process-automation", component: BlogBusinessProcessAutomationComponent,
        data: {
          title: '10 Top Benefits of Business Process Automation ',
          description: '10 Benefits of business process automation that can drive your operational excellence using the custom software solution.',
          keywords: 'Business Process Automation, process automation',
          image: 'https://www.kalpitatechnologies.com/assets/blog/business-process/business-processmain.png',
          url: 'https://www.kalpitatechnologies.com/blogs/business-process-automation'
        }
      },
      {
        path: "digital-transformation", component: BlogDigitalTransformationComponent,
        data: {
          title: 'Enterprise Digital Transformation Strategy for Business Owners ',
          description: 'Stay on top of your game with these enterprise digital transformation strategies & optimize business processes, improve ROI, & enhance customer satisfaction.',
          keywords: 'Enterprise Digital transformation, digital transformation',
          image: 'https://www.kalpitatechnologies.com/assets/blog/digital-transform/digital-mobile.png',
          url: 'https://www.kalpitatechnologies.com/blogs/digital-transformation'
        }
      },
      {
        path: "software-requirement-analysis", component: BlogSoftwarereqAnalysisComponent,
        data: {
          title: 'Complete Guide on Software Requirement Analysis',
          description: 'This extensive guide on software requirement analysis gives a complete overview of its significance and different methods used to perform it.',
          keywords: 'software requirement analysis, software requirement',
          image: 'https://www.kalpitatechnologies.com/assets/blog/software-reqanalysis/software-analyse.png',
          url: 'https://www.kalpitatechnologies.com/blogs/software-requirement-analysis'
        }
      },
      {
        path: "data-obfuscation", component: BlogObfuscationComponent,
        data: {
          title: 'Kalpita Data Obfuscation Tool to Secure Sensitive Data',
          description: 'Explore Kalpita Data Obfuscation tool\'s features, functionalities, and benefits to safeguard your data from any security threats. ',
          keywords: 'data obfuscation, obfuscation',
          image: 'https://www.kalpitatechnologies.com/assets/blog/Obfuscation/cover-obf.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/data-obfuscation'
        }
      },
      {
        path: "custom-web-development", component: BlogCustomWebdevComponent,
        data: {
          title: 'Everything You Need To Know About Custom Web Development',
          description: 'In today\'s competitive digital environment, enhance your digital presence through custom web development from choosing the layout to improving user experience.',
          keywords: 'custom-web-development',
          image: 'https://www.kalpitatechnologies.com/assets/blog/web-development/web-cover.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/custom-web-development'
        }
      },
      {
        path: "devops-guide", component: DevopsGuideComponent,
        data: {
          title: 'The Ultimate Guide to DevOps: Implementation, Tools, and Best Practices',
          description: 'Explore our complete guide to DevOps, covering what is DevOps, tools, benefits and implementation. Optimize your DevOps pipeline for CI/CD to drive success.',
          keywords: 'devops, What is DevOps, DevOps implementation guide, DevOps tools and technologies, Benefits of DevOps, DevOps automation, DevOps best practices, DevOps pipeline optimization, How to implement DevOps, DevOps for continuous integration',
          image: 'https://www.kalpitatechnologies.com/assets/blog/devops-guide/devops-guide-cover.png',
          url: 'https://www.kalpitatechnologies.com/blogs/devops-guide'
        }
      },
      {
        path: "ios-updates", component: IosUpdatesComponent,
        data: {
          title: 'iOS 18: Key Updates, Features & Everything You Need to Know',
          description: 'Explore the latest updates and features of iOS 18. Discover how Apple\'s newest operating system enhances functionality, performance, and user experience.',
          keywords: 'ios update, ios 18, ios 18 update, latest updates, key updates',
          image: 'https://www.kalpitatechnologies.com/assets/blog/ios-updates/iosUpdates-cover.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/ios-updates'
        }
      },
      {
        path: "agentic-ai", component: AgenticAiComponent,
        data: {
          title: 'Core Components of Agentic AI with Examples-A Complete Guide',
          description: 'This Blog explains Agentic AI in simple terms, the core components of Agentic AI, the pros & cons of Agentic AI, its software components, & real-world examples.',
          keywords: 'agentic ai, ai, artificial intelligence, core components of agentic ai, explain agentic ai with an example, software components of agentic ai, what is agentic ai in simple words, components of agentic ai, what is agentic ai in simple terms, what is agentic ai examples, agentic ai core components, agentic ai implementationsd are possible, why is it called agentic ai',
          image: 'https://www.kalpitatechnologies.com/assets/blog/agentic-ai/agentic-card.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/agentic-ai'
        }
      },
      {
        path: "build-website-ai-tools", component: WebsiteUsingaiComponent,
        data: {
          title: 'How to Build a Website with AI Tools: Simple 4-Step Guide',
          description: 'Learn how to build a website using an AI website builder, customize with AI-powered tools, and publish with ease. Enhance your site with the best AI tools!',
          keywords: 'AI tools, AI website builder, ai powered, build a website, how to build a website with ai, AI Website generator, ai powered tools, best ai tools, best website builder for small business',
          image: 'https://www.kalpitatechnologies.com/assets/blog/buildwebsite-usingai/websitebuild-card.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/build-website-ai-tools'
        }
      },
      {
        path: "aitools-project-management", component: AitoolsProjectManagementComponent,
        data: {
          title: 'The 7 Best AI Tools for Project Management in 2025',
          description: 'Get to know the top 7 AI tools for project management in 2025 - including free, AI-powered solutions to boost efficiency, automate tasks & streamline workflows.',
          keywords: 'best ai tools for project management, free ai tools for project management, ai in project management, AI Tools for Project Management, ai powered',
          image: 'https://www.kalpitatechnologies.com/assets/blog/aitools-projectmanagement/aitools-card.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/aitools-project-management'
        }
      },
      {
        path: "artificial-general-intelligence-agi", component: WhatIsArtificialGeneralIntelligenceAgiComponent,
        data: {
          title: 'What is Artificial General Intelligence (AGI) - A Complete Guide',
          description: 'Explore what is Artificial General Intelligence (AGI), how AGI works, its benefits, risks, and how it differs from Narrow AI. Discover the future of AI today.',
          keywords: 'Artificial General Intelligence, AGI, Future of AI, Narrow AI, Intelligent Agents, what is Artificial General Intelligence, AGI vs AI, Benefits of AGI, Challenges of AGI, AGI in Artificial Intelligence, General AI, How AGI works, Risks of Artificial General Intelligence',
          image: 'https://www.kalpitatechnologies.com/assets/blog/aitools-projectmanagement/aitools-card.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/artificial-general-intelligence-agi'
        }
      },
      {
        path: "rag-chatbot", component: RagChatbotComponent,
        data: {
          title: 'What is a RAG Chatbot? Benefits, Use Cases & Architecture',
          description: 'Learn how RAG Chatbots use Retrieval-Augmented Generation to power AI chatbots. Explore RAG model, use cases, benefits & adoption in the USA and India.',
          keywords: 'RAG Chatbots, RAG Chatbot, what is a RAG chatbot, RAG architecture, RAG model, Retrieval-Augmented Generation, AI chatbots, NLP chatbot, RAG chatbot use cases, how RAG chatbots work, RAG chatbot benefits, Generative AI, AI applications in USA, AI adoption in India',
          image: '../../../../assets/blog/RAG-Chatbot/RAGcovercard.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/rag-chatbot'
        }
      },
      {
        path: "agi-implementation-guide", component: AGIImplementationGuideComponent,
        data: {
          title: 'AGI Implementation Guide for Enterprises | Top 10 Insights for AGI in Business 2025',
          description: 'Bring AGI into your business with confidence. This 2025 AGI implementation guide for enterprises explains ethical considerations, governance and compliance, and integrating AGI in business workflows.',
          keywords: 'AGI into your business, AGI ethical considerations, AGI implementation, AGI in business, AGI governance and compliance, AGI implementation guide for enterprises,  AGI in Business Workflows, AGI implementation guide, AGI for your business, narrow AI',
          image: '../../../../assets/blog/RAG-Chatbot/RAGcovercard.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/agi-implementation-guide'
        }
      },
      {
        path: 'agentic-ai-in-sdlc', component: AgenticAiInSdlcComponent,
        data: {
          title: 'Agentic AI in SDLC 2025: Full-Stack Development Across Multi-Cloud Environments',
          description: 'Agentic AI is transforming the Software Development Lifecycle (SDLC) with autonomous agents that streamline backend, APIs, data pipelines, testing, and deployment across AWS, Azure, and GCP. Learn use cases, challenges, and ethical considerations.',
          keywords: 'Agentic AI, Software Development Lifecycle (SDLC), SDLC phases, Full-stack development, Data engineering, Multi-cloud environments, AWS, Azure, GCP, Cross-cloud deployment, Cost optimization, Hyperautomation, Vibe coding, Multi-agent architectures, Agentic DevOps, Automated testing, Human–AI collaboration',
          image: '../../../../assets/blog/agentic-ai-in-sdlc/sdlc-banner-card.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/agentic-ai-in-sdlc'
        }
      },
      {
        path: 'ai-agents-in-enterprises', component: AiAgentsInEnterprisesComponent,
        data: {
          title: 'Rise of AI Agents in Enterprises: Human-Centric Approach Drives Success',
          description: 'Explore how the rise of AI agents in enterprises boosts efficiency, trust, and productivity through human-centric AI strategies for sustainable success.',
          keywords: 'AI agents, AI agents in enterprises, Explainable AI, Human-AI collaboration, Transparent AI systems, How human-centric AI agents improve enterprise efficiency, Best practices for AI agent adoption in businesses, Explainable AI for trust and transparency in enterprises',
          image: '../../../../assets/blog/ai-agents-in-enterprises/sdlc-banner-card.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/ai-agents-in-enterprises'
        }
      },
      {
        path: 'autonomous-machine-revolution', component: AutonomousMachineRevolutionComponent,
        data: {
          title: 'Autonomous Machines & the M2M Economy: AI-Driven Future of Work',
          description: 'Explore how autonomous machines, the AI-driven future of work, IoT, and the machine-to-machine economy are reshaping industries, governance, and global economics.',
          keywords: 'Autonomous machines, machine agency, autonomous systems, artificial intelligence, machine-to-machine economy, M2M economy, automation vs autonomy, future of work, digital wallets, cybersecurity, robot-as-a-service, economic autonomy',
          image: '../../../../assets/blog/ai-agents-in-enterprises/sdlc-banner-card.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/autonomous-machine-revolution'
        }
      },
      {
        path: 'data-visualization-skills-2026', component: DataVisualizationSkills2026Component,
        data: {
          title: 'Data Visualization Skills 2026: AI, SQL & Decision Design',
          description: 'Master the top data visualization skills in 2026 - AI in data visualization, SQL & query optimization, semantic modeling in analytics & decision architecture.',
          keywords: 'data visualization skills 2026, data visualization skills in 2026, AI in data visualization, decision-driven dashboards, Advanced SQL for data analysts, semantic modeling in analytics, data storytelling skills, Decision architecture in analytics, SQL & query optimization, prompt engineering for analysts',
          image: '../../../../assets/blog/ai-agents-in-enterprises/sdlc-banner-card.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/ai-coding-tools-for-developers'
        }
      },
       {
        path: 'ai-coding-tools-for-developers', component: AiCodingToolsForDevelopersComponent,
        data: {
          title: '10 Top AI Coding Tools for Developers in 2026 | AI Coding Assistants',
          description: 'Discover the top 10 AI coding tools for developers in 2026 | AI tools for coding, AI coding assistants, enterprise AI coding tools for modern software development.',
          keywords: 'AI coding tools, AI tools for coding, AI coding tools for developers, best AI coding tools 2026, best AI coding tools, AI coding assistant, best AI tools for developers, AI tools for software development, AI-powered coding tools, AI developer tools, AI code assistants for developers, which AI tool is best for coding, AI tools for code generation and debugging, enterprise AI coding tools',
          image: '../../../../assets/blog/ai-agents-in-enterprises/sdlc-banner-card.webp',
          url: 'https://www.kalpitatechnologies.com/blogs/ai-coding-tools-for-developers'
        }
      }
    ]
  }
]